export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10915.65db092c.jpg";